var pageSizes = {
    a0: {
        width: 2384,
        height: 3370,
    },
    a1: {
        width: 1684,
        height: 2384,
    },
    a2: {
        width: 1191,
        height: 1684,
    },
    a3: {
        width: 842,
        height: 1191,
    },
    a4: {
        width: 595,
        height: 842,
    },
    a5: {
        width: 420,
        height: 595,
    },
    a6: {
        width: 298,
        height: 420,
    },
    a7: {
        width: 210,
        height: 298,
    },
    a8: {
        width: 147,
        height: 210,
    },
    a9: {
        width: 105,
        height: 147,
    },
    a10: {
        width: 74,
        height: 105,
    },
    b0: {
        width: 2835,
        height: 4008,
    },
    b1: {
        width: 2007,
        height: 2835,
    },
    b2: {
        width: 1417,
        height: 2004,
    },
    b3: {
        width: 1001,
        height: 1417,
    },
    b4: {
        width: 709,
        height: 1001,
    },
    b5: {
        width: 499,
        height: 709,
    },
    b6: {
        width: 354,
        height: 499,
    },
    c0: {
        width: 2599,
        height: 3677,
    },
    c1: {
        width: 1837,
        height: 2599,
    },
    c2: {
        width: 1298,
        height: 1837,
    },
    c3: {
        width: 918,
        height: 1298,
    },
    c4: {
        width: 649,
        height: 918,
    },
    c5: {
        width: 459,
        height: 649,
    },
    c6: {
        width: 323,
        height: 459,
    },
    letter: {
        width: 612,
        height: 791,
    },
    legal: {
        width: 612,
        height: 1009,
    },
};

export { pageSizes };
